<div id="ReportFeedbackFormComponent">
    <div class="report-feedback-form-component_description">
        <p>Referente a este Dash, o que achou da performance da empresa?</p>
    </div>
    <div class="report-feedback-form-component_content">
        <p class="report-feedback-form-component_title">
            Escolha de 1 a 5 estrelas para avaliar
        </p>
        <div class="report-feedback-form-component_stars">
            @for (star of [0, 1, 2, 3, 4]; track $index) {
                <i
                    class="fa"
                    [ngClass]="
                        star < selectedStars ? 'fas fa-star' : 'far fa-star'
                    "
                    (click)="selectStar(star)"
                >
                </i>
            }
        </div>
        @if (showChips) {
            <div class="report-feedback-form-component_chips-container">
                <p class="report-feedback-form-component_title">
                    Do que você gostou?
                </p>
                <div class="report-feedback-form-component_chips">
                    @for (chip of chips; track chip.label) {
                        <dsn-chips
                            (click)="selectChip(chip)"
                            [label]="chip.label"
                            [selected]="chip.selected"
                        ></dsn-chips>
                    }
                </div>
            </div>
        }
    </div>
    <div class="report-feedback-form-component_textarea">
        <p class="report-feedback-form-component_title">
            Deixe um comentário para sua contabilidade
        </p>
        <dsn-textarea
            [(ngModel)]="description"
            [placeholder]="'Ex.: gostaria de marcar uma reunião dia X'"
            [disabled]="false"
            [isInvalid]="false"
            [invalidMessage]="'Este campo e obrigatorio!'"
            [rows]="5"
            [cols]="35"
        ></dsn-textarea>
    </div>

    <div class="report-feedback-form-component_button">
        <dsn-button
            iconRight="fas fa-paper-plane"
            [disabled]="!selectedStars"
            label="Enviar para contabilidade"
            type="primary"
            (click)="onSubmit()"
        ></dsn-button>
    </div>
</div>
